var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-menu__avatar",style:(`background: url(${_vm.url + _vm.image}) center/cover no-repeat; width: 80px; height: 80px;`)})
}
var staticRenderFns = []

export { render, staticRenderFns }